module.exports = __webpack_public_path__ + "img/nosotros_16-9_1920.941b3b7a.jpg";